import {SelectableListProps, SelectableList as BaseSelectableList} from '@esgi/ui-kit/control';
import {useFormElementContext} from '@esgi/ui-kit/form';

type Props = Omit<SelectableListProps<any>, 'value' | 'onChange'>;

export function SelectableList(props: Props): JSX.Element {
	const {value, setValue} = useFormElementContext({array: true});
	return <BaseSelectableList {...props} value={value} onChange={setValue}/>;
}
